export enum FieldValidationType {
    BelgianNationalityNumber = 1,
    // Decimal = 2,
    // Integer = 3,
    BelgianIBAN = 4,
    BelgianMobilePhoneNumber = 5,
    BelgianPhoneNumber = 6,
    Email = 7
}